// extracted by mini-css-extract-plugin
export var adjacentSlide = "_sq-9";
export var arrowButtonContainer = "_sq-5";
export var arrowButtonIcon = "_sq-6";
export var carouselArrowButton = "_sq-2";
export var carouselElementContainer = "_sq-1";
export var currentSlide = "_sq-8";
export var left = "_sq-3";
export var otherSlide = "_sq-a";
export var productCarouselContainer = "_sq-0";
export var right = "_sq-4";
export var sliderOverflow = "_sq-7";